/* tslint:disable */
/* eslint-disable */
/**
 * Funnels API
 * API for managing funnels
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { TypeTunnel } from './TypeTunnel';
import {
    TypeTunnelFromJSON,
    TypeTunnelFromJSONTyped,
    TypeTunnelToJSON,
    TypeTunnelToJSONTyped,
} from './TypeTunnel';

/**
 * Création d'un tunnel. Le tunnel naît VIDE : ni garanties, ni frais, ni supports, ni plateformes — tout se paramètre ensuite depuis sa fiche. Pour repartir d'un tunnel existant, c'est la duplication (POST /tunnels/{tunnelId}/dupliquer).
 * @export
 * @interface CreateTunnelCommand
 */
export interface CreateTunnelCommand {
    /**
     * Identifiant métier du tunnel, unique dans toute l'application (API partenaires, imports, paramétrage). Un code déjà pris est refusé.
     * @type {string}
     * @memberof CreateTunnelCommand
     */
    code: string;
    /**
     * 
     * @type {string}
     * @memberof CreateTunnelCommand
     */
    designation: string;
    /**
     * Produit porté par le tunnel. Définitif — il ne se change plus ensuite.
     * @type {string}
     * @memberof CreateTunnelCommand
     */
    produitId: string;
    /**
     * Titulaire attendu du compte bancaire : le back refuse un compte qui ne lui appartient pas.
     * @type {string}
     * @memberof CreateTunnelCommand
     */
    beneficiairePersonneId: string;
    /**
     * 
     * @type {string}
     * @memberof CreateTunnelCommand
     */
    compteBancaireId: string;
    /**
     * Propriétaire / représentant du tunnel (le revendeur), distinct du bénéficiaire du compte bancaire. Un tunnel peut ne pas en avoir.
     * @type {string}
     * @memberof CreateTunnelCommand
     */
    ownerId?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CreateTunnelCommand
     */
    fraisResiliation?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof CreateTunnelCommand
     */
    isActive?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CreateTunnelCommand
     */
    isListingActive?: boolean;
    /**
     * Le courtier peut être prélevé à la place du souscripteur (courtier encaisseur)
     * @type {boolean}
     * @memberof CreateTunnelCommand
     */
    brokerCollectionAllowed?: boolean;
    /**
     * Omis, le tunnel reste Individuel (valeur par défaut de l'entité).
     * @type {TypeTunnel}
     * @memberof CreateTunnelCommand
     */
    typeTunnel?: TypeTunnel | null;
}



/**
 * Check if a given object implements the CreateTunnelCommand interface.
 */
export function instanceOfCreateTunnelCommand(value: object): value is CreateTunnelCommand {
    if (!('code' in value) || value['code'] === undefined) return false;
    if (!('designation' in value) || value['designation'] === undefined) return false;
    if (!('produitId' in value) || value['produitId'] === undefined) return false;
    if (!('beneficiairePersonneId' in value) || value['beneficiairePersonneId'] === undefined) return false;
    if (!('compteBancaireId' in value) || value['compteBancaireId'] === undefined) return false;
    return true;
}

export function CreateTunnelCommandFromJSON(json: any): CreateTunnelCommand {
    return CreateTunnelCommandFromJSONTyped(json, false);
}

export function CreateTunnelCommandFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateTunnelCommand {
    if (json == null) {
        return json;
    }
    return {
        
        'code': json['code'],
        'designation': json['designation'],
        'produitId': json['produitId'],
        'beneficiairePersonneId': json['beneficiairePersonneId'],
        'compteBancaireId': json['compteBancaireId'],
        'ownerId': json['ownerId'] == null ? undefined : json['ownerId'],
        'fraisResiliation': json['fraisResiliation'] == null ? undefined : json['fraisResiliation'],
        'isActive': json['isActive'] == null ? undefined : json['isActive'],
        'isListingActive': json['isListingActive'] == null ? undefined : json['isListingActive'],
        'brokerCollectionAllowed': json['brokerCollectionAllowed'] == null ? undefined : json['brokerCollectionAllowed'],
        'typeTunnel': json['typeTunnel'] == null ? undefined : TypeTunnelFromJSON(json['typeTunnel']),
    };
}

export function CreateTunnelCommandToJSON(json: any): CreateTunnelCommand {
    return CreateTunnelCommandToJSONTyped(json, false);
}

export function CreateTunnelCommandToJSONTyped(value?: CreateTunnelCommand | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'code': value['code'],
        'designation': value['designation'],
        'produitId': value['produitId'],
        'beneficiairePersonneId': value['beneficiairePersonneId'],
        'compteBancaireId': value['compteBancaireId'],
        'ownerId': value['ownerId'],
        'fraisResiliation': value['fraisResiliation'],
        'isActive': value['isActive'],
        'isListingActive': value['isListingActive'],
        'brokerCollectionAllowed': value['brokerCollectionAllowed'],
        'typeTunnel': TypeTunnelToJSON(value['typeTunnel']),
    };
}

